export default {
  pageTitle: {
    id: 'funnel_page_title',
    defaultMessage: 'Your green cart | Back Market',
  },
  pageTitleWithoutPrefix: {
    id: 'page_meta_title_company_name',
    defaultMessage: 'Back Market',
  },
  mobilePlanStep: {
    id: 'funnel_page_step_mobile_plan',
    defaultMessage: '{partnerName} set up',
  },
  accountStep: {
    id: 'funnel_page_step_account',
    defaultMessage: 'Account',
  },
  addressesStep: {
    id: 'funnel_page_step_addresses',
    defaultMessage: 'Addresses',
  },
  paymentStep: {
    id: 'funnel_page_step_payment',
    defaultMessage: 'Payment',
  },
  confirmationStep: {
    id: 'funnel_page_step_confirmation',
    defaultMessage: 'Confirmation',
  },
  previousPage: {
    id: 'funnel_page_previous_page',
    defaultMessage: 'Back to previous page',
  },
  stepperClose: {
    id: 'funnel_page_stepper_close',
    defaultMessage: 'Close',
  },
  stepperCompleted: {
    id: 'funnel_page_stepper_completed',
    defaultMessage: 'Completed',
  },
  stepperCurrent: {
    id: 'funnel_page_stepper_current',
    defaultMessage: 'Current',
  },
  cartStep: {
    id: 'funnel_page_step_cart',
    defaultMessage: 'Cart',
  },
}
